module.exports = __webpack_public_path__ + "static/media/d1e0bb00-cdef-4ab7-a0b4-47842d8aa7ae_1.df4a305cb29c8dfa4f2be0f80ddd2386.7f225b5e.png";